<template>
	<div v-if="miniMapId" class="c-block-list-map-custom">
		<div
			id="minimapbody"
			class="minimapwidget"
			:minimapid="miniMapId"
			style="width: 100%; height: 500px"
		></div>
		<PostScribeScript
			html="<script type='text/javascript' src='//netkort.odsherred.dk/clientapi/minimap2/mmloader.js'></script>"
			@done="loadMap"
		/>
	</div>
</template>

<script>
import PostScribeScript from '~/citi-baseline/components/PostScribeScript';

export default {
	name: 'BlockListMapCustom',
	components: { PostScribeScript },
	inheritAttrs: true,

	props: {
		miniMapId: {
			type: String,
			required: false,
		},
	},

	methods: {
		loadMap() {
			// If a div in the page has class minimapwidget the mmloader should be initialized with that minimapId and mapDiv.
			// Only one minimap version is supported on each page, so we can initialize with the first div found.
			const minimapElements = document.querySelectorAll('.minimapwidget');
			if (
				window.mmLoader !== undefined &&
				minimapElements[0] &&
				document.readyState === 'complete'
			) {
				const { mmLoader } = window;
				const options = {
					minimapId: minimapElements[0].getAttribute('minimapId'),
					mapDiv: minimapElements[0].getAttribute('id'),
				};

				if (!mmLoader.isInitialized) {
					mmLoader.isInitialized = true;
					mmLoader.init(options);
				}
			}
		},
	},
};
</script>
<style>
.c-block-list-map-custom canvas {
	transform: matrix(1, 0, 0, 1, 0, 0) !important;
}

.c-block-list-map-custom .miniMapThemeLegend > div img {
	display: inline;
}
</style>
